export const AI_CHAT_ORIGINS = Object.freeze({
  BORROWER_PORTAL: 'borrower_portal',
  LOAN_APP_GUIDE: 'loan_app_guide',
  MESSAGE_TEMPLATES: 'message_templates',
  SMART_TEMPLATES: 'smart_templates',
  BORROWER_MOBILE: 'borrower_mobile',
  LEAD_GEN: 'lead_gen',
  LOAN_APP_ADVISOR: 'loan_app_advisor'
})
